const Pages = {
    TEST: 0,
    METRICS: 1,
    LOGIN: 2, 
    REGISTER: 3, 
    LOGS: 4, 
  };

export default Pages;